import { Button, Checkbox, Col, Radio, Row, Spin, Tag, TimePicker } from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { PitstopModal } from 'shared';
import { AppStore } from 'stores';
import styled from 'styled-components';

const StyledModal = styled(PitstopModal)`
  && {
    .ant-modal-header {
      margin-bottom: 30px;
      .ant-modal-title {
        color: #02103d;
      }
    }
  }
`;

const CHANGE_USER_NOTIFICATIONS_MODAL_ID = 'CHANGE_USER_NOTIFICATIONS_MODAL_ID';

const UserNotificationsModal = ({
  modalId,
  title,
  isLoading = false,
  onUpdateUserNotifications = () => {},
  notificationsTypesIds = null,
  checkedPriorityList = [],
  defaultSelectedHour = null,
  defaultSelectedWeekDay = null,
  loading = false,
}) => {
  const [selectedWeekDay, setSelectedWeekDay] = useState(null);
  const [selectedHour, setSelectedHour] = useState(null);
  const [priorityCheckedList, setPriorityCheckedList] = useState([]);
  const [weekDayError, setWeekDayError] = useState(false);

  const weekDays = [
    { weekDay: 'Sun', value: 0 },
    { weekDay: 'Mon', value: 1 },
    { weekDay: 'Tue', value: 2 },
    { weekDay: 'Wed', value: 3 },
    { weekDay: 'Thu', value: 4 },
    { weekDay: 'Fri', value: 5 },
    { weekDay: 'Sat', value: 6 },
  ];

  useEffect(() => {
    setSelectedWeekDay(
      defaultSelectedWeekDay !== undefined
        ? parseInt(defaultSelectedWeekDay)
        : null
    );
    setSelectedHour(defaultSelectedHour);
    setPriorityCheckedList(checkedPriorityList);
    setWeekDayError(false);
  }, [checkedPriorityList, defaultSelectedHour, defaultSelectedWeekDay]);

  const onChangePriority = (priority) => {
    if (_.indexOf(priorityCheckedList, priority) !== -1) {
      _.remove(priorityCheckedList, (item) => item === priority);
    } else {
      priorityCheckedList.push(priority);
    }

    setPriorityCheckedList([...priorityCheckedList]);
  };

  const handleSubmit = () => {
    if (selectedWeekDay === null) {
      setWeekDayError(true);
      return;
    }

    onUpdateUserNotifications({
      selectedWeekDay,
      selectedHour,
      priorityCheckedList,
      notificationsTypesIds,
    });
  };

  return (
    <StyledModal
      id={modalId}
      title={title}
      width={850}
      okText="Confirm"
      footer={
        <>
          <Button
            key="back"
            onClick={() => {
              AppStore.openModals.set(
                CHANGE_USER_NOTIFICATIONS_MODAL_ID,
                false
              );
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </>
      }
    >
      {isLoading ? (
        <Spin size="large" />
      ) : (
        <>
          <Row>
            <Col span={12}>
              <p style={{ fontWeight: 700 }}>Run every:</p>
              <Radio.Group
                defaultValue={selectedWeekDay}
                value={selectedWeekDay}
                onChange={(e) => {
                  setSelectedWeekDay(e.target.value);
                  setWeekDayError(false);
                }}
              >
                {weekDays.map((value, index) => {
                  return (
                    <Radio.Button key={index} value={value.value}>
                      {value.weekDay}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
              {weekDayError && (
                <p style={{ color: 'red', marginTop: '5px' }}>
                  Please select a week day
                </p>
              )}
            </Col>
            <Col span={12}>
              <p style={{ fontWeight: 700 }}>At:</p>
              <TimePicker
                use12Hours
                style={{ width: 300 }}
                defaultValue={selectedHour}
                value={selectedHour}
                onChange={(time) => setSelectedHour(time)}
              />
            </Col>
          </Row>

          <p style={{ fontWeight: 700, marginTop: 40 }}>
            Select which priorities to subscribe:
          </p>

          <Row>
            <Col span={24}>
              <Checkbox
                checked={_.indexOf(priorityCheckedList, 'minor') !== -1}
                onChange={() => onChangePriority('minor')}
              >
                <Tag color="#dec431">Minor</Tag>
              </Checkbox>

              <Checkbox
                checked={_.indexOf(priorityCheckedList, 'major') !== -1}
                onChange={() => onChangePriority('major')}
              >
                <Tag color="#e28931">Major</Tag>
              </Checkbox>

              <Checkbox
                checked={_.indexOf(priorityCheckedList, 'critical') !== -1}
                onChange={() => onChangePriority('critical')}
              >
                <Tag color="#f92d2e">Critical</Tag>
              </Checkbox>
            </Col>
          </Row>
        </>
      )}
    </StyledModal>
  );
};

UserNotificationsModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  onUpdateUserNotifications: PropTypes.func,
  notificationsTypesIds: PropTypes.any,
  checkedPriorityList: PropTypes.array,
  defaultSelectedHour: PropTypes.any,
  defaultSelectedWeekDay: PropTypes.any,
  loading: PropTypes.bool,
};

export default UserNotificationsModal;
